<template>
  <div class="body">
    <div class="profileData">
      <Website-Profile-Card
        :loading="loading"
        :domain="domain"
        :companyData="companyData ? companyData : null"
        :contactsData="contactsData ? contactsData : null"
        :totalContacts="totalContacts ? totalContacts : null"
        :updateNewData="updateNewData"
      />
    </div>
  </div>
</template>

<script>
import WebsiteCard from '@/components/otherWebsite/WebsiteProfileCard.vue'
import { get } from './../../assets/util/rest.js'

export default {
  name: 'OtherWebsite',
  props: ['domain'],
  watch: {
    domain: {
      immediate: true,
      handler(newValue, oldValue) {
        if (oldValue != newValue) {
          this.getOtherWebsiteData(newValue)
        }
      }
    }
  },
  data: function() {
    return {
      companyData: null,
      contactsData: null,
      totalContacts: null,
      loading: true
    }
  },
  components: {
    'Website-Profile-Card': WebsiteCard
  },
  methods: {
    updateNewData(data) {
      this.contactsData = Object.assign([], data)
    },
    getOtherWebsiteData(domain) {
      this.loading = true
      get('li/domain/contacts.htm?domain=' + domain + '&limit=3')
        .then(response => {
          this.loading = false
          if (response.status == 200) {
            response
              .json()
              .then(res => {
                if (res && res.companyInfo) {
                  this.companyData = res.companyInfo
                } else {
                  this.companyData = null
                }
                if (res && res.contacts_data) {
                  this.contactsData = res.contacts_data.map(allData => {
                    return {
                      ...allData,
                      uniqueId: Math.ceil(Math.random() * 1000)
                    }
                  })
                } else {
                  this.contactsData = null
                }
                if (res && res.totalContacts) {
                  this.totalContacts = res.totalContacts
                } else {
                  this.totalContacts = null
                }

                //console.log('response response ', res)
              })
              .catch(e => {
                this.loading = false
                console.log('err: ' + e)
              })
          } else {
            this.loading = false
            console.log('status: ' + response.status)
          }
        })
        .catch(e => {
          this.loading = false
          console.log('error: ' + e)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  padding: 40px 0 0;
}
ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
  li {
    display: flex;
    width: 100%;
  }
}

.body {
  position: relative;
  // top: 51px;
  z-index: 0;
  .max-height {
    height: -webkit-fill-available;
  }
}
.blur-li {
  position: sticky;
  justify-content: center;
  bottom: 0px;
  background: rgba(255, 255, 255);
  -webkit-box-shadow: 0px -6px 20px 20px $white;
  box-shadow: 0px -6px 20px 20px $white;
  padding: 20px 0px 20px 0px;
  margin-top: 10px;
  button {
    padding: 14px;
    width: 80%;
    font-size: 16px;
  }
}
</style>
